/** @return {null|string} */
export default function getPropertyVideoUrl(property) {
  const video = property.media
    .find((media) => media.media_category === 'Video');

  return video !== undefined
    ? video.media_url
    : null;
}
